import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=a141abde&scoped=true"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=a141abde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a141abde",
  null
  
)

export default component.exports